import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";
import { A } from "@components/Anchor";
import styles from "@components/Typography/typography.module.css";
import { MAPURL, STOREPROPTYPES } from "./lib/constants";
import cardStyles from "./styles/card.module.css";

export function StoreCardAddress({ isIndex, store }) {
  const { t } = useTranslation("store");
  if (!store) {
    return null;
  }
  const mapLink = MAPURL + store.address;
  const wrapperStyle = `${cardStyles.addressWrapper} ${
    isIndex ? cardStyles.addressWrapperIndex : ""
  }`;
  return (
    <div className={wrapperStyle}>
      <div className={cardStyles.section}>
        <p className={styles.paragraph}>{store.address}</p>
        <A href={mapLink} underline isExternal>
          {t("directions-link")}
        </A>
      </div>

      <div className={cardStyles.section}>
        <p className={styles.paragraph}>{t("contact-us")}:</p>
        <A href={`tel:${store.telephone}`} underline isExternal>
          {store.telephone}
        </A>
        <A href={`mailto:${store.email}`} underline isExternal>
          {store.email}
        </A>
      </div>
    </div>
  );
}

StoreCardAddress.propTypes = {
  isIndex: PropTypes.bool,
  store: STOREPROPTYPES.isRequired,
};

StoreCardAddress.defaultProps = {
  isIndex: false,
};
